import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faPhone,
  faEnvelope,
  faSquareCheck,
} from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../../styles/Contact/Contact.scss";

const Contact = ({ darkTheme }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [hoveredIndices, setHoveredIndices] = useState(new Set());


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://formspree.io/f/mgegdrye", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        // Form submission successful
        console.log("Form submitted successfully");
        // Display success notification
        toast.success("Message sent! 🎉");
        // Reset form data
        setFormData({ name: "", email: "", message: "" });
      } else {
        // Form submission failed
        console.error("Form submission failed");
        // Display error notification
        toast.error("Failed to send email. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      // Display error notification
      toast.error("An error occurred. Please try again.");
    }
  };

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const backgroundColor = darkTheme ? "#00ffff" : "#ff6347";
  const hoverBackgroundColor = darkTheme ? "#ff6347" : "#00ffff";
  const textColor = isHovered ? "black" : "white";

  const text = "CONTACT.";

  const handleMouseOver = (index) => {
    setHoveredIndices((prev) => new Set(prev.add(index)));
  };

  const handleMouseOut = (index) => {
    // Optional: Remove this function if you want to keep the hover effect persistent
  };

  return (
    <>
      <div className={`contact ${darkTheme ? "dark" : "light"}`} id="contact">
      <div className="contact__header" id="contact__heading">
          <h1 className="text-wrapper">
            {text.split("").map((char, index) => (
              <span
                key={index}
                className={hoveredIndices.has(index) ? "gradient-text" : ""}
                onMouseOver={() => handleMouseOver(index)}
                onMouseOut={() => handleMouseOut(index)} // Optional: Remove this if you don't need to reset hover
                style={{ color: darkTheme ? "white" : "black" }}
              >
                {char === " " ? "\u00A0" : char}
              </span>
            ))}
          </h1>
        </div>
        <div className="contact__container">
          <div className="contact__details">
            <div className="contact__form" data-aos="fade-up">
              <form onSubmit={handleSubmit}>
                <input type="hidden" name="form-name" value="contact" />
                <p className="contact__form-group">
                  <label
                    htmlFor="name"
                    style={{ color: darkTheme ? "white" : "black" }}
                  >
                    Name:{" "}
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    autoComplete="off"
                    placeholder="Enter name"
                    required
                    style={{
                      borderBottomColor: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  />
                </p>
                <p className="contact__form-group">
                  <label
                    htmlFor="email"
                    style={{ color: darkTheme ? "white" : "black" }}
                  >
                    Email:{" "}
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    autoComplete="off"
                    placeholder="Enter email"
                    required
                    style={{
                      borderBottomColor: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  />
                </p>
                <p className="contact__form-group">
                  <label
                    htmlFor="message"
                    style={{ color: darkTheme ? "white" : "black" }}
                  >
                    Concern:{" "}
                  </label>
                  <textarea
                    name="message"
                    id="contact__message"
                    cols="20"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Type your messsage"
                    style={{
                      borderBottomColor: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  ></textarea>
                </p>
                <button
                  type="submit"
                  className="contact__send-btn"
                  style={{
                    backgroundColor: isHovered
                      ? hoverBackgroundColor
                      : backgroundColor,
                    color: textColor,
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  Send
                </button>
              </form>
            </div>
          </div>
          <div className="contact__info" data-aos="fade-up">
            <h3
              className="contact__info-title"
              style={{
                color: darkTheme ? "#00ffff" : "#ff6347",
              }}
            >
              Let's Connect
            </h3>
            <div className="contact__info-details">
              <ul>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    size="2x"
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  />
                  <p style={{ color: darkTheme ? "white" : "black" }}>
                    <span>Address:&nbsp;&nbsp;</span>Aligarh, Uttar Pradesh,
                    India
                  </p>
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faPhone}
                    size="2x"
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  />
                  <p style={{ color: darkTheme ? "white" : "black" }}>
                    <span>Phone:</span>&nbsp;&nbsp;(+91) 7417435451
                  </p>
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    size="2x"
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  />
                  <p style={{ color: darkTheme ? "white" : "black" }}>
                    <span>Email:&nbsp;&nbsp;</span>mohdaquib31@gmail.com
                  </p>
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faSquareCheck}
                    size="2x"
                    style={{
                      color: darkTheme ? "#00ffff" : "#ff6347",
                    }}
                  />
                  <p style={{ color: darkTheme ? "white" : "black" }}>
                    <span>Designation:</span>&nbsp;&nbsp;Data Scientist at
                    Extreme Networks
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default Contact;
